import { render } from "./BaseListFiles.vue?vue&type=template&id=728452e8&scoped=true"
import script from "./BaseListFiles.vue?vue&type=script&lang=js"
export * from "./BaseListFiles.vue?vue&type=script&lang=js"

import "./BaseListFiles.vue?vue&type=style&index=0&id=728452e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728452e8"]])

export default __exports__